export const combineValidators = (validators) => (value) => {
  if (!validators) return true;
  const validatorArray = Array.isArray(validators) ? validators : [validators]

  for (const validator of validatorArray) {
    const result = validator(value)
    if (result) {
      return result 
    }
  }
  return true
};